export default "__VITE_ASSET__Dlni1ZuO__"